module.exports = __webpack_public_path__ + "img/header_w.f77a8d9f.png";